import { render, staticRenderFns } from "./PepItemMicroResumo.vue?vue&type=template&id=8fbf4ba0&"
import script from "./PepItemMicroResumo.vue?vue&type=script&lang=js&"
export * from "./PepItemMicroResumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports